import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var CustomLabel = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  margin: ", ";\n  padding: ", ";\n  text-align: ", ";\n  text-transform: ", ";\n  width: ", ";\n  display: ", ";\n  align-items: ", ";\n  gap: ", ";\n  cursor: ", ";\n"], ["\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  margin: ", ";\n  padding: ", ";\n  text-align: ", ";\n  text-transform: ", ";\n  width: ", ";\n  display: ", ";\n  align-items: ", ";\n  gap: ", ";\n  cursor: ", ";\n"])), function (_a) {
    var _b = _a.$color, $color = _b === void 0 ? "#000" : _b;
    return $color;
}, function (_a) {
    var _b = _a.$fontSize, $fontSize = _b === void 0 ? "14px" : _b;
    return $fontSize;
}, function (_a) {
    var _b = _a.$fontWeight, $fontWeight = _b === void 0 ? "500" : _b;
    return $fontWeight;
}, function (_a) {
    var _b = _a.$margin, $margin = _b === void 0 ? "0 0 8px 0" : _b;
    return $margin;
}, function (_a) {
    var _b = _a.$padding, $padding = _b === void 0 ? "0" : _b;
    return $padding;
}, function (_a) {
    var _b = _a.$textAlign, $textAlign = _b === void 0 ? "left" : _b;
    return $textAlign;
}, function (_a) {
    var _b = _a.$textTransform, $textTransform = _b === void 0 ? "none" : _b;
    return $textTransform;
}, function (_a) {
    var _b = _a.$width, $width = _b === void 0 ? "auto" : _b;
    return $width;
}, function (_a) {
    var _b = _a.$display, $display = _b === void 0 ? "block" : _b;
    return $display;
}, function (_a) {
    var _b = _a.$alignItems, $alignItems = _b === void 0 ? "center" : _b;
    return $alignItems;
}, function (_a) {
    var _b = _a.$gap, $gap = _b === void 0 ? "4px" : _b;
    return $gap;
}, function (_a) {
    var _b = _a.$cursor, $cursor = _b === void 0 ? "inherit" : _b;
    return $cursor;
});
var templateObject_1;
